import type { MarketVariants } from '@/lib/i18n'

export type Slide02Copy = {
  title: string
  body: string
}

export const copy: MarketVariants<Slide02Copy> = {
  US: {
    title: 'Scams used to be obvious',
    body: 'A shady salesman at the door. A clumsy email from a foreign "prince". The warning signs used to be easier to spot.',
  },
  ar: {
    title: 'كان الاحتيال واضحاً في الماضي',
    body: 'بائع مريب على الباب. رسالة إلكترونية ركيكة من "أمير" أجنبي. كانت علامات التحذير أسهل في اكتشافها.',
  },
}
